import PropTypes from "prop-types"
import React from "react"
import Helmet from "react-helmet"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { compose, defaultProps, lifecycle, withState } from "recompose"
import { Dimmer, Loader } from "semantic-ui-react"
import Layout from "./components/layout"
import { setConfiguration } from "./redux/modules/configuration"

const App = ({ isLoadingConfiguration, title }) => (
	<React.Fragment>
		<Helmet>
			<html lang="pl" />
			<title>{title}</title>
		</Helmet>
		{isLoadingConfiguration ? (
			<Dimmer active page>
				<Loader size="big">Pobieranie konfiguracji...</Loader>
			</Dimmer>
		) : (
			<Layout />
		)}
	</React.Fragment>
)

App.propTypes = {
	isLoadingConfiguration: PropTypes.bool,
	title: PropTypes.string.isRequired
}

const mapDispatchToProps = dispatch => ({
	setConfiguration: configuration => dispatch(setConfiguration(configuration))
})

const enhance = compose(
	withRouter,
	connect(
		undefined,
		mapDispatchToProps
	),
	defaultProps({
		title: "Wyszukiwarka statusów spraw"
	}),
	withState("isLoadingConfiguration", "setLoadingConfiguration", true),
	lifecycle({
		async componentDidMount() {
			const { setConfiguration, setLoadingConfiguration } = this.props
			try {
				const response = await fetch(`${process.env.PUBLIC_URL}/config.json`)
				const configuration = await response.json()
				setConfiguration(configuration)
			} catch (error) {
			} finally {
				setLoadingConfiguration(false)
			}
		}
	})
)

export { App, enhance }
export default enhance(App)



// WEBPACK FOOTER //
// ./src/App.js